import React, { useContext, useEffect, useState } from "react";
import "./UseSandbox.scss";
import { Button } from "react-bootstrap";
import { authContext } from "../../../../provider/Context/AuthContext";
import { EAccountStatus } from "../../../../common/enum/EAccountStatus";
import { onBoardingBusinessNameLocalStorageKey, userDetailsLocalStorageKey } from "../../../../common/constant";
import LocalStorageService from "../../../../services/local.storage.service";
import DITYPES from "../../../../config/di.types";
import DIContainer from "../../../../config/di.container";
import UserDetails from "../../../../common/model/UserDetails";

export interface IUseSandbox {
    handleSubmit: any;
    handleOnChange: any;
    isApplicationPending: boolean;
    businessName?: string;
    email?: string
}
const localStorageService = DIContainer.get<LocalStorageService>(DITYPES.LocalstorageService);

const UseSandbox: React.FC<IUseSandbox> = (props) => {
    const FORGET_PASSWORD_URL = process.env.REACT_APP_FORGET_PASSWORD_URL;
    const [siteOwner, setSiteOwner] = useState<any>();

    useEffect(() => {
        props.handleSubmit("usesandbox", 20);
    }, [])


    const onSubmitClickHandler = () => {
        props.handleSubmit("usesandbox", 100);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.isApplicationPending) {
            props.handleOnChange("usesandbox", 100)
        }

        var userDetails: UserDetails = new UserDetails();
        Object.assign(userDetails, JSON.parse(localStorageService.get(userDetailsLocalStorageKey) || '{}'));

        setSiteOwner(userDetails.BusinessName);

    }, [props.isApplicationPending])

    return (
        <div className="sandbox-container">{props.isApplicationPending &&
            <div className="mt-md-5">
                <h2 className="ob-heading">Pending Request to Go Live</h2>
                <div className="subtext">
                    We are in the process of reviewing your information. Please give us 2
                    business days to reply after submitting your application. If it has been
                    longer than 2 business days and you have not
                    yet heard back from our Mindbody Developer Team,
                    please contact us at <a id="btn-api-email" className="sb-sb-link" href="mailto:api@mindbodyonline.com">api@mindbodyonline.com</a>.
                </div>
            </div>
        }
            <div className="mt-md-5">
                <h2 className="ob-heading">Use Free Sandbox</h2>
                <div className="subtext">
                    The Mindbody <a id="btn-sandbox" className="sb-sb-link" href="https://clients.mindbodyonline.com/ASP/su1.asp?studioid=-99" target="_blank">Sandbox</a> is a free experimenting and testing environment that is designed to test and build your integrations. Our Sandbox is refreshed
                    every night at 12:00&nbsp;AM&nbsp;PST so you can continue to test variations of your integrations on a daily basis. Check out our <a id="btn-sandbox-testing" className="sb-sb-link" href="/PublicDocumentation/V6##testing-your-integration" target="_blank">Sandbox testing documentation</a> for more information.
                </div>
            </div>
            <div className="mt-md-5">
                <h2 className="ob-heading">Sandbox Site Login - </h2>
                <div className="subtext d-flex">
                    <span className="sb-login-span">Studio Id: -99</span>
                    <span className="sb-login-span">User Name: mindbodysandbox99@gmail.com</span>
                    <span className="sb-login-span">Password: Apitest1234</span>
                </div>
            </div>
            <div className={'more-info-section mt-md-4 ' + (props.isApplicationPending == true ? 'more-info-section-app-pend' : '')}>
                <hr className="sandbox-hr"></hr>
                <h2 className="ob-heading sb-heading pl-md-4">More Information:</h2>
                <hr></hr>
                <div>
                    <h5 className="ob-sub-heading pl-md-4">Your API credentials</h5>
                </div>
                <div className="more-information pl-md-4 pb-md-4">
                    <div>Source name: <span className="sb-so-color">{siteOwner}</span></div>
                    <div>Forgot your source password? <a id="btn-reset-password" className="sb-fp-link" href={FORGET_PASSWORD_URL}>Reset source password</a></div>
                </div>
                <div className="more-information pl-md-4 pb-md-3">
                    <a id="btn-public-documentations" className="sb-fp-link" target="_blank" href="/PublicDocumentation/V6">Find out more in our API documentation</a>
                </div>
            </div>            
            {!props.isApplicationPending &&
                <div>
                    <div className="mt-md-4 mb-md-5">
                        <h2 className="ob-heading sb-heading">Request to Go Live</h2>
                        <div className="subtext">
                            Ready to go live? Fill out a brief form and submit your request for credentials.
                            Our goal is to get you up and running as quickly as possible.
                            Please expect a response within 2 business days.
                        </div>
                    </div>
                    <div className="button-div mb-md-5">
                        <Button id="btn-request-live-access" onClick={onSubmitClickHandler} variant="primary" type="submit" className="btn-block">
                            Request live access
                </Button>
                    </div>
                </div>
            }
        </div>
    );
}

export default UseSandbox;